export const requestDesktopAppVersionAction = () => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.requestDesktopAppVersion();
};
